import { render, staticRenderFns } from "./SelectListaComponent.vue?vue&type=template&id=5281e83a"
import script from "./SelectListaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectListaComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports